import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const customHeading = cva(undefined, {
  variants: {
    alignment: {
      left: ['text-left'],
      center: ['text-center'],
      right: ['text-right'],
    },
  },
  defaultVariants: {
    alignment: 'left',
  },
})

export type CustomHeadingProps = VariantProps<typeof customHeading>
